<template>
  <header class="header-bar">
    <div class="header-left">
      <div class="logo-box">
        <span class="logo-mark">D</span>
      </div>
      <div class="header-title">
        <div class="sub-title">Campus Dormitory Management System</div>
        <div class="main-title">校园宿舍管理系统</div>
      </div>
    </div>
    <div class="header-right">
      <!-- 只有当前路径不是 login 时显示退出按钮 -->
      <button v-if="!isLoginPage" class="logout-btn" @click="logout">退出登录</button>
    </div>
  </header>
</template>

<script>
import {closeWsClient } from '@/utils/wsInstance'
export default {
  name: 'HeaderLogo',
  computed: {
    // 计算属性判断当前路由是否为 login
    isLoginPage() {
      return this.$route.name === 'Login';
    }
  },
  methods: {
    logout() {
      localStorage.clear()
      this.$router.replace({ name: 'Login' });
      closeWsClient()
      window.location.reload(); 
    }
  }
}
</script>

<style scoped>
.header-bar {
  height: 60px;
  background: radial-gradient(circle at 0% 0%, #020617 0, #020617 45%, #000000 100%);
  color: #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.85);
}

.header-left {
  display: flex;
  align-items: center;
}

.logo-box {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: radial-gradient(circle at 30% 0%, #1e3a8a 0, #020617 55%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.9);
}

.logo-mark {
  font-size: 20px;
  font-weight: 800;
  letter-spacing: 1px;
  color: #60a5fa;
}

.header-title .sub-title {
  font-size: 11px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  opacity: 0.7;
}

.header-title .main-title {
  font-size: 18px;
  font-weight: 600;
  margin-top: 2px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.env-tag {
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid rgba(147, 197, 253, 0.7);
  font-size: 12px;
  color: #bfdbfe;
  background: rgba(15, 23, 42, 0.7);
}

.logout-btn {
  padding: 6px 14px;
  border-radius: 999px;
  border: 1px solid rgba(248, 113, 113, 0.8);
  background: rgba(127, 29, 29, 0.85);
  color: #fee2e2;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.16s ease-out;
}

.logout-btn:hover {
  background: rgba(185, 28, 28, 0.95);
  box-shadow: 0 6px 18px rgba(248, 113, 113, 0.6);
}

@media (max-width: 600px) {
  .header-bar {
    height: 52px;
    padding: 0 12px;
  }
  .logo-box {
    display: none;
  }
  .header-title .main-title {
    font-size: 16px;
  }
  .env-tag {
    display: none;
  }
  .logout-btn {
    padding: 4px 10px;
    font-size: 12px;
  }
}
</style>
